import analytics from '@iui-kit/utils/analytics'
import { BRIEF_CREATE_EVENT } from '@src/constants/AdvertisingBriefs'
import { redirectUserTo } from '@src/utils/redirectUser'

export const sendBriefAnalytics = (briefId: string, redirectUrl?: string, userID?: number) => {
  const dataLayerOptions = {
    event: BRIEF_CREATE_EVENT,
    brief_id: briefId, // eslint-disable-line
    eventCallback: () => {
      if (redirectUrl) {
        redirectUserTo(redirectUrl)
      }
    },
    eventTimeout: 2000
  }

  if (userID) {
    Object.assign(dataLayerOptions, { user_id: userID }) // eslint-disable-line
  }

  analytics.sendEvent(dataLayerOptions)
}
